import React, { FC, useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { axiosInstance } from "../../utility/apiInstance";
import toast from "react-hot-toast";
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { ACL_ROUTE, Role } from "../../utility/constant";
import { useNavigate, Link } from "react-router-dom";

const LoginPage: FC = () => {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const navigate = useNavigate();

  const [user, setUser] = useState({
    username: "",
    password: "",
    isLoggedIn: false,
    token: "",
    error: "",
  });



  const onLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const response = await axiosInstance.post(
        "/api/v1/customers-auth/login",
        {
          username: username,
          password: password,
        }
      );

      localStorage.setItem("email", response?.data?.data?.customer?.contactInfo?.email);
      if (response.status === 200 && response.data.data.token) {
        setUser({
          ...user,
          isLoggedIn: true,
          token: response.data.data.token,
        });
        localStorage.setItem("token", response?.data?.data?.token);
        toast.success("Login successful! Welcome back.");
        const role: Role = response.data.data.customer.role;
        navigate(ACL_ROUTE[role]?.[0]);
      }
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";
      toast.error(errorMessage);
      setUser({
        ...user,
        error: errorMessage,
      });
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <>
      <div className="sgateloginMain">
        <div className="sgateloginInner">
          <div className="sgLoginBox">
            <div className="sgLoginLeft">
              <div className="sgLoginLeftinn">
                <div className="sgLeftcontent">
                  <h1>
                    Welcome to <span className="blink">CargoDash</span>{" "}
                    Tracking!
                  </h1>

                  <p>
                    Your all-in-one solution for staying informed about your
                    shipment's progress. Receive intelligent notifications
                    through WhatsApp and Email. Begin tracking your shipment
                    today!
                  </p>
                </div>
                <figure className="slogintrack">
                  <img src="/images/sgate-track.png" alt="Track shipments" />
                  <div className="circle-ripple"></div>
                </figure>

                <i className="logoicon">
                  <img src="/images/sgate-icon.png" alt="SGATE icon" />
                </i>
              </div>
            </div>
            <div className="sgLoginRight">             
              <div className="sgRightBox">
                <figure className="slogo">
                  <img src="/images/logo.png" alt="SGATE logo" />
                </figure>

                <div className="sgLoginTittle">
                  <article>
                    {" "}
                    <i>
                      <img src="/images/signicon.png" alt="Sign icon" />
                    </i>
                    <h3>Sign In</h3>
                  </article>
                </div>

                <div className="loginform loginline">
                  <CssBaseline />
                  <div className="formBox">
                    <Box component="form" onSubmit={onLogin} sx={{ mt: 1 }}>
                       <div className="form-group">
                        <label className="form-label">User Name<span className="redAstric">*</span></label>
                        <TextField
                          margin="normal"
                          required
                          fullWidth
                          type="username"
                          id="username"
                          //label="Username"
                          name="username"
                          autoComplete="username"
                          value={username}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            setUsername(e.target.value)
                          }
                          InputLabelProps={{
                            shrink: true,
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "#ddd",
                              },
                              "&:hover fieldset": {
                                borderColor: "#ddd",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "#ddd",
                              },
                              "& .MuiInputBase-input": {
                                color: "#838285",
                              },
                              "&:hover .MuiInputBase-input": {
                                color: "#fab800",
                              },
                              "&.Mui-focused .MuiInputBase-input": {
                                color: "#fab800",
                              },
                            },
                            "& .MuiFormLabel-root": {
                              color: "#838285",
                            },
                            "& .MuiFormLabel-root.Mui-focused": {
                              color: "#fab800",
                            },
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Password<span className="redAstric">*</span></label>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            required
                          >
                           
                            <OutlinedInput
                              id="outlined-adornment-password"
                              type={showPassword ? "text" : "password"}
                              value={password}
                              required
                              inputProps={{
                                maxLength: 20,
                              }}
                              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                setPassword(e.target.value)
                              }
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                  >
                                    {showPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              }
                              
                              sx={{
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#ddd",
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#ddd",
                                },
                                "& fieldset": {
                                  borderColor: "#ddd",
                                },
                              }}
                            />
                          </FormControl>
                      </div>
                      

                      <div className="logBtn">
                        <Button
                              className="btn btnTheme"
                              type="submit" 
                              variant="contained"
                              // sx={{
                              //   mt: 3,
                              //   mb: 2,
                              //   backgroundColor: "#fab800",
                              //   color: "white",
                              // }}
                            >
                              Login
                            </Button>
                      </div>
                        
                      <div className="registerAccountMain">
                       <div className="registerAccount">
                        <p>Don’t have an account? <Button
                          // className="btn btnTheme"
                          type="button"
                          // fullWidth
                          // variant="contained"
                          // sx={{
                          //   mt: 3,
                          //   mb: 2,
                          //   backgroundColor: "#fab800",
                          //   color: "white",
                          // }}
                          onClick={() => {
                            const host = window.location.hostname;

                            if (host.includes("localhost") || host.includes("dev")) {
                              window.location.href = "https://hub-dev.cargodash.in/authentication/signup";
                            } else {
                              window.location.href = "https://hub.cargodash.in/authentication/signup";
                            }
                          }}
                        >
                          Sign Up
                        </Button></p>
                        </div>
                        <div className="forgotPassword">
                          <Link to="/auth/ForgetPassword">Forgot Password?</Link>
                        </div>
                      </div>
                        


                    </Box>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
